/* ============
 * Home Index Page
 * ============
 *
 * The home index page
 */
import wordboardService from '@/services/wordboard';
import store from '@/store';

export default {
  data() {
    return {
      wordboardDialogVisible: false,
      deleteDialog: false,
      editDialog: false,
      form: {
        title: '',
        text: '',
      },
      rules: {},
      selectedWordBoard: {},
      pageSize: 10,
      selectedPage: 1,
    };
  },
  mounted() {
    this.fetchPage();
  },
  components: {
    VLayout: require('@/layouts/default/default.vue'),
    VPanel: require('@/components/panel/panel.vue'),
  },
  computed: {
    wordboards() {
      return store.state.wordboard.wordboards;
    },
    count() {
      return store.state.wordboard.count;
    },
  },
  methods: {
    async onSubmit(form) {
      this.wordboardDialogVisible = false;
      this.$refs.form.validate(async valid => {
        if (valid) {
          await wordboardService.create($.extend({}, form));
          this.form.title = '';
          this.form.text = '';
        } else {
          return false;
        }
      });
    },
    fetchPage() {
      store.dispatch('wordboard/getWords', {
        filter: {
          limit: this.pageSize,
          skip: (this.selectedPage - 1) * this.pageSize,
        },
      });
    },
    confirmDelete(wb) {
      this.selectedWordBoard = wb;
      this.deleteDialog = true;
    },
    async deleteSelectedWordboard() {
      this.deleteDialog = false;
      await wordboardService.del(this.selectedWordBoard);
      this.fetchPage();
    },
    showEditDialog(brand) {
      this.form = $.extend({}, brand);
      this.editDialog = true;
    },
    async onSubmitEdit(form) {
      this.editDialog = false;
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          await wordboardService.edit($.extend({}, form));
          this.fetchPage();
          this.form = {};
          return true;
        }
        return false;
      });
    },
    handlePageChange(page) {
      this.selectedPage = page;
      this.fetchPage();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchPage();
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/wordboard/index.js